import { render, staticRenderFns } from "./ParentChildRelationModal.vue?vue&type=template&id=55a0cafd&scoped=true"
import script from "./ParentChildRelationModal.vue?vue&type=script&lang=js"
export * from "./ParentChildRelationModal.vue?vue&type=script&lang=js"
import style0 from "./ParentChildRelationModal.vue?vue&type=style&index=0&id=55a0cafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a0cafd",
  null
  
)

export default component.exports